const HERO_DATA = {
  title: 'Golden View Dine',
  text: 'Explore the authentic vegan dishes with your friends and family',
  btn: {
    label: 'Read more',
    href: '#'
  }
};
export default HERO_DATA;